document.addEventListener('turbo:load', () => {
  $(document).on('click', '[data-dismiss="alert-message"]', (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    let $el = ev.currentTarget.closest('.alert-message');
    $el.classList.remove('show');
    setTimeout(150, () => $el.remove());
  });
});